<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Student Question View </span>
        </v-row>
        <br />
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
                <v-overlay :value="loader" absolute>
			Loading
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
        <v-card>
            <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                <center class="heading"><strong>Student Question View</strong></center>
                <v-divider></v-divider><br />
                <v-row class="c-box card-border">
                    <v-col cols="12" sm="12">
                        <center><strong>Course: {{course_code}}:{{course_name}}</strong></center>
                    </v-col>
                </v-row>
                <v-card class="box card-border" v-for="(item,index) in question_bank_info" :key="item.id">
                    <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                        <v-row class="q-box card2">
                            <!-- <v-col cols="12" lg="1"> <strong>Q:</strong>{{index + 1}} 
                    </v-col> -->
                    <div style="padding: 12px;"> <strong>Q:</strong>{{index + 1}} </div>
                            <v-col cols="12" lg="11">
                                <span class="span-mr" v-if="item.question_text" v-html="item.question_text">
                                    {{item.question_text}}
                                </span>
                                <span class="span-mr" v-if="item.quefile">
                                    <img class="imgs" :src="item.quefile" @click="zooimg(item.quefile) " />
                                </span>
                            </v-col>
                        </v-row>
                        <br />
                        <v-row class="pl-5" style="padding: 0px 20px 20px 20px;">
                            <strong>Option:</strong>
                        </v-row>
                        <v-row v-for="(option) in item.option_list" :key="option.id">
                            <v-col cols="12" sm="12" md="12" class="p-zero">
                                <v-row class="vrow" >
                                    <div class="opt">
                                        <div class="opt-label">{{option.option_name}}</div>
                                    </div>
                                    <input class="radiospace" type="radio" v-if="option.iscorrect" disabled />
                                    <input type="radio" name="opt" class="radiospace" v-else v-model="opt_id" v-bind:value="option.id" disabled />
                                    <span class="span-mr" v-if="option.option_value" v-html="option.option_value">
                                        {{option.option_value}}
                                    </span>
                                </v-row>

                                <v-row class="vrow" >
                                    <span v-if="option.answerfile">
                                        <img class="imgs" :src="option.answerfile" @click="zooimg(option.answerfile) " />
                                    </span>
                                </v-row>
                            </v-col>
                        </v-row>
                        <div class="correct-ans">
                            <div class="correct-ans-text">
                                <span>Correct Answer:<span style="font-weight: bold; padding: 5px;">{{item.answer}}</span></span>
                            </div>
                        </div>
                    </v-col>
                </v-card>
                <br />
            </v-col>
        </v-card>
        <v-dialog v-model="dialog_zooimg" persistent max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="headline">Image Pre-View</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <img class="rounded w-100 d-block imgs-preview" :src="img_url" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog_zooimg = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import { VueMathjax } from "vue-mathjax";
    import MathLive from "mathlive";
    export default {
        components: {
            "vue-mathjax": VueMathjax,
        },
        data: () => ({
            overlay: false,
            loader:false,
            snackbar_msg: "",
            opt_id: "",
            dialog_zooimg: false,
            img_url: null,
            snackbar: false,
            color: "",
            iseditable: false,
            load: false,
            dialog: false,
            question_bank_info: null,
            course_code: null,
            course_name: null,
            errorMsg: {
                course: false,
            },
            editorConfig: {
                // The configuration of the editor.
                extraPlugins: "mathjax",
                //mathJaxLib: 'http://cdn.mathjax.org/mathjax/2.6-latest/MathJax.js?config=TeX-AMS_HTML',
                mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
            },
        }),
        updated: function () {
            console.log("Inside updated");
            this.$nextTick().then(() => {
                if (window.MathJax) {
                    console.log("rendering mathjax");
                    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
                }
            });
        },

        mounted() {
            this.loader = true
            this.examtype = this.$route.params.examtype_id;
            this.courseId = this.$route.params.courseId;
            this.questypeid = this.$route.params.questypeid;
            const data = {
                course_Id: this.courseId,
                exam_type_id: this.examtype,
                questypeid: this.questypeid,
            };
            axios
                .post("/StudentQbankView/getqbankinfo", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.question_bank_info = res.data.question_bank_info;
                        this.course_code = res.data.course_code;
                        this.course_name = res.data.course_name;
                        //   this.showSnackbar("#4caf50", "Load Successfully..."); // show snackba

                        for (let que = 0; que < this.question_bank_info.length; que++) {
                            for (let op = 0; op < this.question_bank_info[que].option_list.length; op++) {
                                if (this.question_bank_info[que].option_list[op].iscorrect == true) {
                                    this.question_bank_info[que].answer = this.question_bank_info[que].option_list[op].option_name;
                                    // alert(this.question_bank_info[que].answer)
                                }
                            }
                        }
                        console.log("this.question_bank_info", this.question_bank_info);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                 .finally(() => {
                        this.loader = false
                });
        },
        methods: {
            zooimg(url_img) {
                //alert("zooimg"+url_img)
                this.img_url = url_img;
                this.dialog_zooimg = true;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
.p-zero{
    padding: 0px;
}
    .correct-ans {
        display: flex;
        justify-content: flex-end;
    }
    .correct-ans-text {
        background: hsla(190, 99%, 30%, 1);
        color: white;
        padding: 0.5rem;
    }
    .opt {
        background: #607d8b;
        border: 4px solid #a4edf1;
        border-radius: 30px;
        color: white;
        font-size: 16px;
        font-weight: bold;
        margin-top: 0.3%;
        height: 2rem;
        width: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }
    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 80%;
    }
    .btn-style {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        font-weight: bold;
        padding-top: 1rem !important;
    }
    a {
        text-decoration: underline;
    }
    .card-border {
        border: 3px solid hsla(190, 99%, 30%, 1) !important;
        border-radius: 15px;
        padding: 5px;
        margin: 1rem !important;
        width: auto;
    }
    .toolbar {
        text-align: center !important;
        background-color: #424093 !important;
        color: #ffffff !important;
    }
    .btn-submit:hover {
        background-color: #ffab0e !important;
        color: #ffffff !important;
    }
    thead {
        background-color: #ffab0e !important;
        white-space: nowrap !important;
    }
    th {
        color: #ffffff !important;
    }
    .span-mr {
        margin: 0rem !important;
        padding: 0px;
        padding-top: 0.5rem;
    }
    .span-mr1 {
        margin: 0.2rem !important;
        padding: 0px;
    }
    .span-mr >>> p{
margin: 0;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .card1 {
        background: #28b315;
        height: 40px;
        border: 2px solid #28b315;
        border-radius: 5px;
        padding: 5px;
        width: auto;
    }
    .card2 {
        background: #f79b07;
        /* height: 40px; */
        border: 2px solid #f79b07;
        border-radius: 5px;
        padding: 5px;
        width: auto;
    }
    .toolbar-title {
        color: #ffffff !important;
    }
    .box {
        background-color: white !important;

        margin: 8px !important;
        padding: 8px;
        color: hsla(190, 99%, 30%, 1) !important;
    }
    .c-box {
        background-color: white !important;
        background-color: #add8e630 !important;
        margin: 8px !important;
        padding: 8px;
        color: hsla(190, 99%, 30%, 1) !important;
    }
    .q-box {
        background-color: #add8e630 !important;
        margin: 8px !important;
        padding: 8px;
        color: hsla(190, 99%, 30%, 1) !important;
        border-radius: 0px;
    }
    .vrow {
        /* margin: 0.5rem !important; */
        padding: 0;
        margin-left: 1rem;
    }
</style>
